export const VERIFY_SUCCESS = "VERIFY_SUCCESS";
export const VERIFY_FAILURE = "VERIFY_FAILURE";
export const UPDATE_USER_DETAILS = "UPDATE_USER_DETAILS";

export const GET_MATERIAL_RECORDS_SUCCESS = "GET_MATERIAL_RECORDS_SUCCESS";
export const GET_MATERIAL_RECORDS_REQUEST = "GET_MATERIAL_RECORDS_REQUEST";
export const GET_MATERIAL_RECORDS_FAILURE = "GET_MATERIAL_RECORDS_FAILURE";
export const RECORD_UNARCHIVED_SUCCESS = "RECORD_UNARCHIVED_SUCCESS";

export const UPDATE_ALL_COMPANY_USERS = "UPDATE_ALL_COMPANY_USERS";
export const UPDATE_COMPANY_LEVEL_OPTIONS = "UPDATE_COMPANY_LEVEL_OPTIONS";

export const UPDATE_ALL_JOBS = "UPDATE_ALL_JOBS";
export const CREATED_NEW_JOB = "CREATED_NEW_JOB";
export const JOB_UPDATED = "JOB_UPDATED";
export const JOB_DELETED = "JOB_DELETED";
export const SET_SELECTED_JOB = "SET_SELECTED_JOB";

export const UPDATE_ALL_VENDORS = "UPDATE_ALL_VENDORS";
export const DOES_VENDOR_EXIST = "DOES_VENDOR_EXIST";
export const CREATED_NEW_VENDOR = "CREATED_NEW_VENDOR";
export const VENDOR_UPDATED = "VENDOR_UPDATED";
export const VENDOR_DELETED = "VENDOR_DELETED";
export const SET_SELECTED_VENDOR = "SET_SELECTED_VENDOR";
export const UPDATE_VENDOR_CONTACTS = "UPDATE_VENDOR_CONTACTS";

export const UPDATE_ALL_MATERIAL_OWNERS = "UPDATE_ALL_MATERIAL_OWNERS";
export const CREATED_NEW_MATERIAL_OWNER = "CREATED_NEW_MATERIAL_OWNER";
export const DOES_OWNER_EXIST = "DOES_OWNER_EXIST";
export const SET_SELECTED_MATERIAL_OWNER = "SET_SELECTED_MATERIAL_OWNER";
export const MATERIAL_OWNER_UPDATED = "MATERIAL_OWNER_UPDATED";
export const GET_ARCHIVED_RECORDS_SUCCESS = "GET_ARCHIVED_RECORDS_SUCCESS";
export const RESET_LAST_VISIBLE = "RESET_LAST_VISIBLE";

export const UPDATE_CURRENT_JOB_EQUIPMENT = "UPDATE_CURRENT_JOB_EQUIPMENT";
export const SET_EQUIPMEMNT_JOB = "SET_EQUIPMEMNT_JOB";
export const CREATE_EQUIPMET_ORDER_DONE = "CREATE_EQUIPMET_ORDER_DONE";
export const UPDATE_EQUIPMET_ORDER_DONE = "UPDATE_EQUIPMET_ORDER_DONE";
export const SET_SELECTED_JOB_EQUIPMENTS = "SET_SELECTED_JOB_EQUIPMENTS";
export const UPDATE_RETURNED_EQUIPMENTS = "UPDATE_RETURNED_EQUIPMENTS";
export const UPDATE_EQUIPMENT_RECORD_CONTACTS =
  "UPDATE_EQUIPMENT_RECORD_CONTACTS";
export const CREATE_EQUIPMET_RETURN_TO_SHOP_DONE =
  "CREATE_EQUIPMET_RETURN_TO_SHOP_DONE";
export const RE_ASSIGN_ITEM_TO_JOB_DONE = "RE_ASSIGN_ITEM_TO_JOB_DONE";
export const UPDATE_EQUIPMENT_RECORD_RETURN_TO_SHOP_DONE =
  "UPDATE_EQUIPMENT_RECORD_RETURN_TO_SHOP_DONE";
export const DELETE_EQUIPMENT_ORDER_DONE = "DELETE_EQUIPMENT_ORDER_DONE";
export const RETURN_EQUIPMENT_ORDERS_TO_SHOP =
  "RETURN_EQUIPMENT_ORDERS_TO_SHOP";
export const UPDATE_ALL_COMPANY_JOBS = "UPDATE_ALL_COMPANY_JOBS";
export const UPDATE_RETURNS = "UPDATE_RETURNS";
export const FETCH_ALL_JOBS_EQUIPMENT_HIDABLE_COLUMNS_DONE =
  "FETCH_ALL_JOBS_EQUIPMENT_HIDABLE_COLUMNS_DONE";
export const UPDATE_ALL_JOBS_EQUIPMENT_HIDABLE_COLUMNS_DONE =
  "UPDATE_ALL_JOBS_EQUIPMENT_HIDABLE_COLUMNS_DONE";
export const UPDATE_EQUIPMENTS_FILTERED = "UPDATE_EQUIPMENTS_FILTERED";

export const START_LOADING = "START_LOADING";
export const FINISH_LOADING = "FINISH_LOADING";
export const OPEN_TOAST_DIALOG = "OPEN_TOAST_DIALOG";
export const CLOSE_TOAST_DIALOG = "CLOSE_TOAST_DIALOG";

export const UPDATE_MANUFATURERS_AND_SHIP_LOCATIONS =
  "UPDATE_MANUFATURERS_AND_SHIP_LOCATIONS";

export const UPDATE_ALL_TOOLS = "UPDATE_ALL_TOOLS";
export const UPDATE_SINGLE_TOOL_DONE = "UPDATE_SINGLE_TOOL_DONE";
export const UPDATE_TOOL_GROUP_DONE = "UPDATE_TOOL_GROUP_DONE";
export const CREATED_NEW_TOOL = "CREATED_NEW_TOOL";
export const UPDATE_ALL_TOOL_NAMES = "UPDATE_ALL_TOOL_NAMES";
export const UPDATE_ALL_MULTI_SELECTED_TOOLS =
  "UPDATE_ALL_MULTI_SELECTED_TOOLS";
export const UPDATE_ALL_MULTI_SELECTED_TOOL_NAMES =
  "UPDATE_ALL_MULTI_SELECTED_TOOL_NAMES";
export const TOOLS_CHECKOUT_DONE = "TOOLS_CHECKOUT_DONE";
export const TOOLS_CHECKIN_DONE = "TOOLS_CHECKIN_DONE";
export const UPDATE_CURRENT_TOOLS = "UPDATE_CURRENT_TOOLS";
export const UPDATE_MULTI_SELECTED_TOOL_NAMES_DETAILS =
  "UPDATE_MULTI_SELECTED_TOOL_NAMES_DETAILS";
export const UPDATE_SIMPLE_TOOL_DETAILS = "UPDATE_SIMPLE_TOOL_DETAILS";
export const DELETE_TOOL_GROUP_DONE = "DELETE_TOOL_GROUP_DONE";
export const TOOLS_TRANSFER_DONE = "TOOLS_TRANSFER_DONE";
export const DELETE_TOOL_DONE = "DELETE_TOOL_DONE";

export const UPDATE_NOTIFICATIONS = "UPDATE_NOTIFICATIONS";

export const PRINT_DATA_VISUALIZATION = "PRINT_DATA_VISUALIZATION";
